<template>
  <v-autocomplete
    hide-details="auto"
    :items="Waiter"
    :loading="loading"
    v-model="selectedWaiter"
    item-text="name"
    item-value="id"
    label="Waiter"
    clearable
    outlined
    dense
    @change="onChange"
    :search-input.sync="searchWaiter"
  ></v-autocomplete>
</template>
<script>
export default {
  props: {
    value: {
      type: [Number, String],
      default: null,
    },
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    Waiter: [],
    selectedWaiter: null,
    searchWaiter: null,
    loading: false,
  }),
  methods: {
    onChange(value) {
      this.$emit("input", value || null);
    },
    getWaiterByQuery(query = "") {
      this.loading = true;
      this.$store
        .dispatch("waiter/GetWaiters", {
          query: query,
          status: "active",
        })
        .then((res) => {
          this.Waiter = res.data.data || [];
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    async ensureSelectedWaiterLoaded(waiterId) {
      if (!waiterId) return;
      const numericId = Number(waiterId);
      const exists = this.Waiter.some((w) => Number(w.id) === numericId);
      if (exists) {
        this.selectedWaiter = numericId;
        return;
      }
      try {
        const res = await this.$store.dispatch("waiter/GetSingleWaiter", numericId);
        if (res && res.data) {
          this.Waiter = [res.data, ...this.Waiter.filter((w) => Number(w.id) !== numericId)];
          this.selectedWaiter = numericId;
        }
      } catch (err) {
        this.selectedWaiter = numericId;
      }
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (val != null && val !== "") {
          this.ensureSelectedWaiterLoaded(val);
        } else {
          this.selectedWaiter = null;
        }
      },
    },
    clear: {
      handler() {
        this.selectedWaiter = null;
        this.$emit("input", null);
      },
      deep: true,
    },
    searchWaiter(val) {
      this.getWaiterByQuery(val || "");
    },
  },
  created() {
    this.getWaiterByQuery();
    if (this.value != null && this.value !== "") {
      this.ensureSelectedWaiterLoaded(this.value);
    }
  },
};
</script>
